import Vue from 'vue';
import {
  messageFormat,
  formatDateTime,
  sendMsgFormat
} from "@/utils/ChatUtils";
import store from "@/store";
import Audio from "@/utils/Audio";
import EventBus from "@/utils/eventBus";
import conf from "../../views/im/conf/index.js";
import RequestUtils from "@/utils/RequestUtils";

export default{
  namespaced: 'lazada', //具名引用时使用
  state: {                 //state状态管理(通过store.state.name访问)
    token: {},
    // 当前的用户
    user: {},
    websocket: {},

    messageList: [],
    // 当前聊天窗口
    currentChat: {},
    // 所有的聊天窗口
    chatList: [],
    //刷新token 定时器
    flushTokenTimerId: null,

    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
    },
    storeList: [],
    storeData: {},
    sessionData: {},
    currentSessionData: {},
    messageData: {},
    currentStore: {},
    sellerData: {},
    orderData: {},
    productData: {},
    voucherData: {},
    searchSession: {},
    sessionTab: ['invition', 'recently']
  },
  getters: {               // state的计算属性(通过store.getters.lastName访问)    

  },
  mutations: {          // mutations改变store的状态（通过store.commit('SET_NAME', 'qian')提交修改）
    setStoreList: function (state, storeList) {
      let storeOpt = [{
        'id': 0,
        'name': '全部',
        'active': true
      }]
      for (let i=0; i<storeList.length; i++) {
        Vue.set(state.storeData, storeList[i]['seller_id'], {unread_count: 0, transfer_count: 0});
        Vue.set(state.sessionData, storeList[i]['seller_id'], {session_list: []});
        Vue.set(state.orderData, storeList[i]['seller_id'], {});
        Vue.set(state.productData, storeList[i]['seller_id'], {});
        Vue.set(state.voucherData, storeList[i]['seller_id'], {});
        Vue.set(state.messageData, storeList[i]['seller_id'], {});
        storeList[i]['unread_count'] = 0;
        storeList[i]['transfer_count'] = 0;
        storeOpt.push({
          'id': storeList[i].id,
          'name': storeList[i].name,
        })
      }
      state.currentStore = storeList[0];
      state.storeList = storeList;
      // set option
      store.state.storeOpt['lazada'] = storeOpt;
    },
    // 设置店铺属性
    setStoreAttr: function (state, data) {
      for (let i=0; i<state.storeList.length; i++) {
        if (state.storeList[i].id == data.id) {
          if (data.attr) {          
            state.storeList[i][data.attr] = data.value;
          } else {
            state.storeList[i] = data;
          }
          break;
        }
      }
    },
    setSessionData: function (state, sessionData) {
      Vue.set(state.sessionData, sessionData.store.seller_id, sessionData);
      // if (sessionData.session_list) {      
      //   Vue.set(state.currentSessionData, sessionData.seller_id, sessionData.session_list[0]);
      // }
      this.commit("lazada/calcStoreUnread", sessionData.store.seller_id);
      this.commit("lazada/sortSessionList", {seller_id: sessionData.store.seller_id});
    },
    setRecentlyData: function (state, data) {
      let seller_id = state.currentStore.seller_id;
      state.sessionData[seller_id]['recently'] = data;
    },
    setCurrentSessionData: function (state, session) {
      Vue.set(state.currentSessionData, state.currentStore.seller_id, session);
    },
    setSessionDataBySid: function (state, session) {
      for (let j=0; j<state.sessionTab.length; j++) {
        let session_list = state.sessionData[state.currentStore.seller_id][state.sessionTab[j]].data;
        for (let i=0; i < session_list.length; i++)
        {
          if (session_list[i].session_id == session.session_id) {
            state.sessionData[state.currentStore.seller_id][state.sessionTab[j]].data[i] = session;
            this.commit("lazada/calcStoreUnread", state.currentStore.seller_id);
            break;
          }
        }
      }
    },
    /**
     * 设置消息
     * @param {[type]} state       [description]
     * @param {[type]} messageData [description]
     */
    setMessageData: function (state, messageData) {
      let currentSession = state.currentSessionData[state.currentStore.seller_id];
      messageData.message_list = messageData.message_list.map(function(elem) {
        elem.format_content = messageFormat(elem.template_id, elem.content);
        elem.sys_notice = elem.template_id == 2 ? 1 : 0;
        elem.timestamp = formatDateTime(new Date(elem.send_time));
        if (elem.from_account_type == 2) {
          elem.avatar = state.currentStore.logo_url;
        } else {          
          elem.avatar = currentSession.head_url;
        }
        return elem;
      });
      state.messageData[state.currentStore.seller_id] = messageData;
      if (store.state.translate) {
        this.commit("lazada/getTransMessage");
      }
    },
    setCurrentStore: function (state, currentStore) {
      state.currentStore = currentStore;
    },
    pushSessionList: function (state, sessionData) {
      let seller_id = sessionData.seller_id;
      let tab = sessionData.tab;
      for (let i=0; i<sessionData.data.data.length; i++)
      {      
        state.sessionData[seller_id][tab].data.push(sessionData.data.data[i]);
      }
      state.sessionData[seller_id][tab].total = sessionData.data.total;
      state.sessionData[seller_id][tab].per_page = sessionData.data.per_page;
      state.sessionData[seller_id][tab].current_page = sessionData.data.current_page;
      state.sessionData[seller_id][tab].last_page = sessionData.data.last_page;

      this.commit("lazada/calcStoreUnread", seller_id);
    },
    invitationSession: function (state, data) {
      let seller_id = data.store.seller_id;
      let invition = state.sessionData[seller_id]['invition'].data;
      for (let i=0; i<invition.length; i++) {
        if (invition[i].id == data.from_session_id) {
          state.sessionData[seller_id]['invition'].data.splice(i, 1);
          break;
        }
      }
      if (data.to_session) {
        state.sessionData[seller_id]['recently'].data.unshift(data.to_session);
        this.commit("lazada/sortSessionList", {
          seller_id: seller_id,
          tab: 'recently'
        });
      }
    },
    transferSession: function (state, data) {
      let seller_id = data.store.seller_id;
      let tab = '';
      let list = null;
      for (let j=0; j<state.sessionTab.length; j++) {
        tab = state.sessionTab[j];
        list = state.sessionData[seller_id][tab].data;
        for (let i=0; i<list.length; i++) {
          if (list[i].id == data.from_session_id) {
            state.sessionData[seller_id][tab].data.splice(i, 1);
            break;
          }
        }
      }
      if (data.to_session) {
        state.sessionData[seller_id]['recently'].data.unshift(data.to_session);
        this.commit("lazada/calcStoreUnread", seller_id);
        this.commit("lazada/sortSessionList", {
          seller_id: seller_id,
          tab: 'recently'
        });
      }
    },
    // 设置消息id
    setMessageId: function (state, data) {
      let msgLen = state.messageData[data.seller_id].message_list.length - 1;
      for (let i=msgLen; i>=0; i--) {
        if ( state.messageData[data.seller_id].message_list[i].message_id == data.temp_message_id ) {
          state.messageData[data.seller_id].message_list[i].message_id = data.message_id;
          break;
        }  
      }
    },
    // 设置消息id
    setMessageTxt: function (state, data) {
      let msgLen = state.messageData[data.seller_id].message_list.length - 1;
      for (let i=msgLen; i>=0; i--) {
        if ( state.messageData[data.seller_id].message_list[i].message_id == data.temp_message_id ) {
          state.messageData[data.seller_id].message_list[i].content = JSON.stringify({"txt":data.transTxt});
          state.messageData[data.seller_id].message_list[i].format_content = data.transTxt;
          console.log(state.messageData[data.seller_id].message_list[i]);
          break;
        }  
      }
    },
    sortSessionList: function (state, data) {
      let tabs = [];
      if (!data || !data.tab) {
        tabs = state.sessionTab;
      } else {
        tabs = [data.tab];
      }
      console.log('sortSessionList');
      for (let i=0; i<tabs.length; i++) {
        state.sessionData[data.seller_id][tabs[i]].data.sort(function (a, b) {
          if (b.unread_count != a.unread_count) {
            return b.unread_count - a.unread_count;
          } else if (b.transfer_mark != a.transfer_mark) {
            return b.transfer_mark - a.transfer_mark;
          } else {          
            return b.sort_time - a.sort_time;
          }
        });
      }
    },
    calcStoreUnread: function (state, seller_id) {
      let unread_count = 0;
      let transfer_count = 0;
      for (let j=0; j<state.sessionTab.length; j++) {
        let session_list = state.sessionData[seller_id][state.sessionTab[j]].data;
        for (let i=0; i < session_list.length; i++)
        {
          unread_count += (!isNaN(session_list[i]['unread_count']) ? session_list[i]['unread_count'] : 0);
          transfer_count += session_list[i]['transfer_mark'];
        }
      }
      Vue.set(state.storeData, seller_id, {unread_count: unread_count, transfer_count: transfer_count});
      for (let j=0; j<state.storeList.length; j++) {
        if (seller_id == state.storeList[j].seller_id) {
          state.storeList[j].unread_count = unread_count;
          state.storeList[j].transfer_count = transfer_count;
          break;
        }
      }
      state.storeList.sort(function (a, b) {
        if (b.unread_count == a.unread_count) {
          return b.transfer_count - a.transfer_count;
        } else {        
          return b.unread_count - a.unread_count;
        }
      })
    },
    messageHanle: function (state, data) {
      if (data.receive_type == 'conversation') {
        // 会话分配给当前客服
        let seller_id = data.session_detail.seller_id;
        let invition = state.sessionData[seller_id]['invition'].data;
        for (let i=0; i<invition.length; i++) {
          if (invition[i].id == data.session_detail.id) {
            state.sessionData[seller_id]['invition'].data.splice(i, 1);
            break;
          }
        }
        data.tab = 'recently';
        this.commit("lazada/updateSession", data);
      } else if (data.receive_type == 'notice') {
        // 会话提示
        let seller_id = data.session_detail.seller_id;
        if (data.session_detail.csr) {
          // 该会话已分配，从未分配里移除
          let invition = state.sessionData[seller_id]['invition'].data;
          for (let i=0; i<invition.length; i++) {
            if (invition[i].id == data.session_detail.id) {
              state.sessionData[seller_id]['invition'].data.splice(i, 1);
              break;
            }
          }
          // 当前客服是主管则都显示在已分配
            data.tab = 'recently';
            this.commit("lazada/updateSession", data);
        } else {
          data.tab = 'invition';
          this.commit("lazada/updateSession", data);
        }
      }
    },
    updateSession: function (state, sessionData) {
      let tabs = sessionData.tab ? [sessionData.tab] : ['invition', 'recently'];
      let session = sessionData.session_detail;
      let notice = false;
      let flag = true;
      let session_list = null;
      let tab = '';
      for (let j=0; j<tabs.length; j++) {
        tab = tabs[j];
        session_list = state.sessionData[session.seller_id][tab].data;

        for (let i=0; i<session_list.length; i++) {
          if (session_list[i].session_id == session.session_id) {
            flag = false;
            if ( session.unread_count > session_list[i].unread_count ) {
              notice = true;
            }
            state.sessionData[session.seller_id][tab].data[i] = session;
          }
        }
        if (flag && (sessionData.sync_type && sessionData.sync_type != 'SESSION_UPDATE')) {
          state.sessionData[session.seller_id][tab].data.push(session);
          notice = true;
        }
        this.commit("lazada/calcStoreUnread", session.seller_id);
        this.commit("lazada/sortSessionList", {
          seller_id: session.seller_id,
          tab: tab
        });
      }
      if (notice) {
        Audio.tingNotice();
      }
    },
    readSession: function (state) {
      let param = new FormData();
      let msglen = state.messageData[state.currentStore.seller_id].message_list.length;
      let message_id = state.messageData[state.currentStore.seller_id].message_list[msglen-1].message_id;
      if (message_id.indexOf('sending') == -1) {      
        param.set("store_id", state.currentStore.id);
        param.set("session_id", state.currentSessionData[state.currentStore.seller_id].session_id);
        param.set("last_read_message_id", message_id);
        RequestUtils.request(conf.readSession(), param)
        .then(() => {
          this.commit("lazada/resetUnRead");
        })
      }
    },
    updateMessage: function (state, session) {
      let currentSession = state.currentSessionData[state.currentStore.seller_id];
      let messageData = state.messageData[state.currentStore.seller_id];
      if (currentSession && currentSession.session_id == session.data.session_id) {

        let flag = true;
        for (let i=0; i<messageData.message_list.length; i++) {
          if (messageData.message_list[i].message_id == session.data.message_id) {
            flag = false;
          }
        }
        if (flag && session.data.content) { 
          let sessiondata = session.data;
          sessiondata.format_content = messageFormat(sessiondata.template_id, sessiondata.content);
          sessiondata.sys_notice = sessiondata.template_id == 2 ? 1 : 0;
          sessiondata.timestamp = formatDateTime(new Date(sessiondata.send_time));
          if (sessiondata.from_account_type == 2) {
            sessiondata.avatar = state.currentStore.logo_url;
          } else {          
            sessiondata.avatar = currentSession.head_url;
          }
          state.messageData[state.currentStore.seller_id].message_list.push(sessiondata);

          EventBus.$emit('lazadaAddmsgCallback');
          this.commit("lazada/sortMessage");
          if (sessiondata.from_account_type != 2) {
            this.commit("lazada/readSession");
          }
          // 翻译
          if (store.state.translate) {
            this.commit("lazada/getTransMessage");
          }
          return true;
        }
      }
      return false;
    },
    sortMessage: function (state) {
      state.messageData[state.currentStore.seller_id].message_list.sort(function (a, b) {
        return a.send_time - b.send_time;
      });
    },
    /**
     * 添加消息
     * @param  {[type]} state   [description]
     * @param  {[type]} message [description]
     * @return {[type]}         [description]
     */
    pushMessageList: function (state, message) {
      let message_list = message.message_list;
      let currentSession = state.currentSessionData[state.currentStore.seller_id];
      let messageData = state.messageData[state.currentStore.seller_id];

      message_list = message_list.map(function(elem) {
        elem.format_content = messageFormat(elem.template_id, elem.content);
        elem.sys_notice = elem.template_id == 2 ? 1 : 0;
        elem.timestamp = formatDateTime(new Date(elem.send_time));
        if (elem.from_account_type == 2) {
          elem.avatar = state.currentStore.logo_url;
        } else {          
          elem.avatar = currentSession.head_url;
        }
        return elem;
      });

      for (let i=0; i<messageData.message_list.length; i++)
      {      
        message_list.push(messageData.message_list[i]);
      }
      state.messageData[state.currentStore.seller_id] = {
        message_list: message_list, 
        last_message_id: message.last_message_id,
        next_start_time: message.next_start_time,
        has_more: message.has_more
      }
      if (store.state.translate) {
        this.commit("lazada/getTransMessage");
      }
    },
    addMessage: function(state, message) {
      console.log(message);
      let currentSession = state.currentSessionData[state.currentStore.seller_id];
      let data = {
        content: sendMsgFormat(message),
        from_account_id:    state.currentStore.seller_id,
        from_account_type:  2,
        message_id:         message.message_id,
        send_time:          (new Date()).getTime(),
        session_id:         currentSession.session_id,
        site_id:            currentSession.site_id,
        status:             0,
        template_id:        message.template_id,
        to_account_id:      currentSession.buyer_id,
        to_account_type:    1,
        type: 1,
      }
      if (message.data.trans_result) {
        data.trans_result = message.data.trans_result;
      }
      let msg = {
        seller_id: state.currentStore.seller_id,
        data: data
      }
      console.log(msg);
      this.commit("lazada/updateMessage", msg);
    },
    // 已读会话
    resetUnRead: function(state) {
      let currentSession = state.currentSessionData[state.currentStore.seller_id];
      let session_list = state.sessionData[ state.currentStore.seller_id ].recently.data;
      for (let i=0; i < session_list.length; i++) {
        if (session_list[i].session_id == currentSession.session_id) {
          state.sessionData[ state.currentStore.seller_id ].recently.data[i].unread_count = 0;
          break;
        }
      }
      this.commit("lazada/calcStoreUnread", state.currentStore.seller_id);
    },
    // 修改转移标志
    updateTransferMark: function (state) {
      let currentSession = state.currentSessionData[state.currentStore.seller_id];
      let session_list = state.sessionData[ state.currentStore.seller_id ].recently.data;
      if (currentSession.transfer_mark == 1) {
        let param = new FormData();
        param.set("store_id", state.currentStore.id);
        param.set("session_id", state.currentSessionData[state.currentStore.seller_id].id);
        RequestUtils.request(conf.updateTransferMark(), param)
        .then(() => {
          for (let i=0; i < session_list.length; i++) {
            if (session_list[i].session_id == currentSession.session_id) {
              state.sessionData[ state.currentStore.seller_id ].recently.data[i].transfer_mark = 0;
              this.commit("lazada/calcStoreUnread", state.currentStore.seller_id);
              break;
            }
          }
        })
      }
    },
    // 查询会话
    setSearchSession: function (state, data) {
      console.log(data);
      if (data == null) {
        state.searchSession = {load: 2};
      } else {      
        data.load = data.total == 0 ? 1 : 3;
        if (data.current_page == 1) {        
          state.searchSession = data;
        } else {
          console.log(state.searchSession);
          for (let i=0; i<data.data.length; i++) {
            state.searchSession.data.push(data.data[i]); 
          }
          state.searchSession.current_page = data.current_page;
          state.searchSession.last_page = data.last_page;
        }
      }
    },
    /**
     * 设置订单数据
     * @param {[type]} state [description]
     * @param {[type]} data  [description]
     */
    setOrderData: function (state, data) {
      let seller_id = state.currentStore.seller_id;
      if (data == null) {
        state.orderData[seller_id] = {load: 2};
      } else {      
        for (let i=0; i<data.data.length; i++) {
          data.data[i].moreshow = false;
        }
        data.load = data.total == 0 ? 1 : 3;
        if (data.current_page == 1) {        
          state.orderData[seller_id] = data;
        } else {
          for (let i=0; i<data.data.length; i++) {
            state.orderData[seller_id].data.push(data.data[i]); 
          }
          state.orderData[seller_id].current_page = data.current_page;
          state.orderData[seller_id].last_page = data.last_page;
        }
      }
    },
    /**
     * 获取更多订单数据
     * @param  {[type]} state [description]
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    orderMoreShow: function (state, index) {
      let seller_id = state.currentStore.seller_id;
      state.orderData[seller_id].data[index].moreshow = !state.orderData[seller_id].data[index].moreshow;
    },
    /**
     * 设置产品数据
     * @param {[type]} state [description]
     * @param {[type]} data  [description]
     */
    setProductData: function (state, data) {
      let seller_id = state.currentStore.seller_id;
      if (data == null) {
        state.productData[seller_id] = {load: 2};
      } else {      
        data.load = data.total == 0 ? 1 : 3;
        if (data.current_page == 1) {        
          state.productData[seller_id] = data;
        } else {
          for (let i=0; i<data.data.length; i++) {
            state.productData[seller_id].data.push(data.data[i]); 
          }
          state.productData[seller_id].current_page = data.current_page;
          state.productData[seller_id].last_page = data.last_page;
        }
      }
    },
    
    setProductValue: function (state, data) {
      let seller_id = state.currentStore.seller_id;
      for (let key in data) {
        state.productData[seller_id][key] = data[key];
      }
    },
    // 优惠券
    setVoucherData: function (state, data) {
      let seller_id = state.currentStore.seller_id;
      if (data == null) {
        state.voucherData[seller_id] = {load: 2};
      } else {
        data.load = data.voucher_list.length > 0 ? 3 : 1;
        state.voucherData[seller_id] = data;
      }
    },
    /**
     * 打开会话
     * @param  {[type]} state [description]
     * @param  {[type]} data  [description]
     * @return {[type]}       [description]
     */
    openSession(state, data) {
      let param = new FormData();
      
      param.set("store_id", data.store_id);
      param.set("order_id", data.ordersn ? data.ordersn : '');
      param.set("buyer_id", data.buyer_id ? data.buyer_id : '');

      RequestUtils.request(conf.openSession('lazada'), param, {loading: true})
      .then((json) => {
        EventBus.$emit('setPlatform', 'lazada');
        for (let i=0; i<state.storeList.length; i++) {
          if (state.storeList[i].id == data.store_id) {          
            this.commit("lazada/setCurrentStore", state.storeList[i]);
          }
        }
        this.commit("lazada/updateSession", {session_detail: json['session']});
        this.commit("lazada/setCurrentSessionData", json['session']);

        EventBus.$emit('openSession', json['session']);
      })
    },
    /**
     * 获取需要翻译的消息
     * @param  {[type]} state [description]
     * @return {[type]}       [description]
     */
    getTransMessage(state) {
      let transQuerys = new Array();
      let message_list = state.messageData[state.currentStore.seller_id].message_list;
      message_list.map(function (elem) {
        if ( elem.template_id == 1 && !elem.trans_result ) {
          transQuerys.push({
            'src': JSON.parse(elem.content)['txt'],
            'message_id': elem.message_id
          });
        }
      })
      this.commit("lazada/translateMessage", transQuerys);
    },
    /**
     * 翻译消息
     * @param  {[type]} state [description]
     * @param  {[type]} data  [description]
     * @return {[type]}       [description]
     */
    translateMessage(state, transQuerys) {
      if (transQuerys.length == 0) return false;
      let param = new FormData();
      param.set("querys", JSON.stringify(transQuerys));
      param.set("to", 'zh');
      param.set("connector", 'lazada');

      RequestUtils.request(conf.translantText(), param)
      .then(json => {
        let messageData = state.messageData[state.currentStore.seller_id];
        messageData = JSON.parse(JSON.stringify(messageData));
        json.trans_result.map(function(elem) {
          for (let i=0; i<messageData.message_list.length; i++)
          {
            if ( messageData.message_list[i].message_id == elem.message_id ) {
              messageData.message_list[i].trans_result = {"zh": elem.dst};
            } 
          }
        })
        Vue.set(state.messageData, state.currentStore.seller_id, messageData);
      })
    },
    setUser: function(state, user) {
      state.user = user;
    },
    // 退出登录
    closeConnect: function(state) {
      state.websocket.heartReset();
      state.websocket.close();
    },
    // 退出后清除内存中的聊天信息
    clear: function(state) {
      state.storeList = [];
      state.storeData = {};
      state.sessionData = {};
      state.messageData = {};
      state.currentSessionData = {};
      state.currentStore = {};
      state.sellerData = {};
    },
    setMessageList: function(state, messageList) {
      state.messageList = messageList;
    },
    resetData: function (state) {
      state.currentSessionData = {};
      state.currentStore = {};
    }
   
  },
  actions: {              // actions提交mutations

  },
  modules: {  //子模块，一般在主模块中用到
  
  }
  
}